import React from 'react'
import styled from '@emotion/styled'
import Async from 'react-promise'
import { spacer, fontSize } from 'stylist'
import EnsureSession from 'components/EnsureSession'
import ModalSection from 'components/ModalSection'
import Container, { NoPadContainer } from 'components/Container'
import PlainLink from 'components/PlainLink'
import { GrowCol } from 'components/Col'
import PurchaseSummary from './summary'
import PurchaseForm from './form'
import { searchParams } from 'utils'
import { getSample } from 'utils/api'

const Section = styled(ModalSection)`
  .top-text {
    ${fontSize('s')};
    margin-bottom: ${spacer(4)};
  }

  .toc-text {
    ${fontSize('s')};
    margin-top: ${spacer(4)};
  }
`

const sampleID = searchParams().get('id')
const liveURL = searchParams().get('live_url')

const RoutePurchase = () => (
  <EnsureSession>
    <Async
      promise={getSample(sampleID)}
      then={({ data }) => (
        <Section>
          <Container>
            <GrowCol>
              <NoPadContainer className="top-text">
                By launching you are agreeing to purchase this sample.
              </NoPadContainer>
              <PurchaseSummary
                vendor={data.vendor}
                sampleSize={data.sample_size}
                cpi={data.cpi}
              />
              <NoPadContainer>
                <div className="toc-text">
                  These Additional{' '}
                  <PlainLink
                    href="https://www.focusvision.com/additional-terms-and-conditions-for-use-of-focusvision-marketplace/"
                    target="_blank"
                  >
                    Terms and Conditions
                  </PlainLink>{' '}
                  for Use of Forsta Sample Marketplace describe your rights and
                  responsibilities and state the terms and conditions under
                  which you access Forsta Sample Marketplace in association with
                  your use of Forsta Services. Please read this document
                  carefully. By continuing to use the Forsta Services, you are
                  indicating your acceptance to be bound by the terms and
                  conditions of this Agreement between you and Forsta.
                  <br />
                  <br />
                  Please note that final control of total survey completes
                  should be limited by you, the user, as to the quota (specific
                  number of requested qualified recipients) set within your
                  survey. If your survey does not include this quota limitation,
                  you will be responsible for any charges or fees incurred due
                  to an over-sampling or an over-spend within Sample
                  Marketplace.
                </div>
              </NoPadContainer>
              <PurchaseForm sampleID={sampleID} liveURL={liveURL} />
            </GrowCol>
          </Container>
        </Section>
      )}
    />
  </EnsureSession>
)

export default RoutePurchase



// WEBPACK FOOTER //
// ./src/routes/purchase/index.js